import { useRef } from 'react';
import { ColumnsType } from 'antd/lib/table';
import { useTableScroll } from '../../hooks/useTableScroll';
import { useColumnDateTimeSearch } from '../../../../hooks/FilterTable/date';
import { ReceitaType, useReceitas } from '../../hooks/useReceitas';
import { useGetColumnSearchPropsTypeString, useGetColumnSearchPropsTypeStringPrefix } from '../../../../hooks/FilterTable/objString';
import { Button, Empty, Table, Tag, Typography } from 'antd';
import { ScrollToBottomButton, ScrollToTopButton } from '../../../../components/ScrollButtunsTable';
import { IReceitasConfiguracoes, STATUS_TAG_COLOR } from '../../interface';

interface IProps {
    type: ReceitaType;
    theme: string;
    onEdit: (record: any) => void;
    receitasHook: ReturnType<typeof useReceitas>;
}

const { Text } = Typography;

export const TabelaReceita = ({ type, theme, onEdit, receitasHook }: IProps) => {
    const { data, loading } = receitasHook;

    const {
        tableRef,
        scrollToTable
    } = useTableScroll();

    const refTotalFiltrado = useRef<IReceitasConfiguracoes[]>([]);

    const columns: ColumnsType<IReceitasConfiguracoes> = [
        {
            title: "Código",
            dataIndex: "codigo_mestre",
            key: "codigo_mestre",
            ellipsis: true,
            ...useGetColumnSearchPropsTypeStringPrefix('codigo_mestre'),
        },
        {
            title: "Tipo",
            dataIndex: "tipo_descricao",
            key: "tipo_descricao",
            ellipsis: true,
            ...useGetColumnSearchPropsTypeString('tipo_descricao')
        },
        {
            title: "Atualizada em",
            dataIndex: "atualizado_em",
            key: "atualizado_em",
            ...useColumnDateTimeSearch('atualizado_em'),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            filters: [
                { text: "Resolvido", value: "resolvido" },
                { text: "Parcial", value: "parcial" },
                { text: "Não Resolvido", value: "nao_resolvido" },
            ],
            onFilter: (value, record) => record.status === value,
            render: (status: string) => {
                const mapStatus = STATUS_TAG_COLOR[status];
                return <Tag color={mapStatus.color}>{mapStatus.label}</Tag>;
            },
        },
        {
            title: "Ações",
            render: (record: IReceitasConfiguracoes) => {
                return (
                    <>
                        <div
                            className="divAcao"
                        >
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: record.status === "nao_resolvido" ? "green" : "#1890ff",
                                    borderColor: record.status === "nao_resolvido" ? "green" : "#1890ff"
                                }}
                                onClick={() => onEdit(record)}
                            >
                                {record.status === "nao_resolvido" ? "Resolver" : "Editar"}
                            </Button>
                        </div>
                    </>
                )
            },
        },
    ];

    return (
        <>
            <div ref={tableRef}>
                <Table
                    rowKey="codigo"
                    loading={loading}
                    dataSource={data}
                    columns={columns}
                    size="small"
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: true,
                        defaultPageSize: 50,
                        position: ['bottomRight'],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    onChange={(_, __, ___, extra) => {
                        refTotalFiltrado.current = extra.currentDataSource;
                    }}
                    title={(registros) => (
                        <div
                            style={{
                                backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                marginBottom: -8,
                                margin: -8,
                                textAlign: 'end',
                            }}
                        >
                            <ScrollToBottomButton
                                registros={registros}
                                onClick={() => scrollToTable('bottom')}
                            />
                            <Text>
                                {`Mostrando: ${registros.length} de ${refTotalFiltrado.current.length > 0 ? refTotalFiltrado.current.length + ' em' : ''} um total de ${data.length} Receitas`}
                            </Text>
                        </div>
                    )}
                    footer={(registros) => (
                        <div style={{ textAlign: 'end' }}>
                            <ScrollToTopButton
                                registros={registros}
                                onClick={() => scrollToTable('top')}
                            />
                            <Text>
                                {`Mostrando: ${registros.length} de ${refTotalFiltrado.current.length > 0 ? refTotalFiltrado.current.length + ' em' : ''} um total de ${data.length} Receitas`}
                            </Text>
                        </div>
                    )}
                    locale={{
                        emptyText: (
                            <Empty
                                image={Empty.PRESENTED_IMAGE_DEFAULT}
                                description={`Não há receitas ${type} disponíveis.`}
                            />
                        )
                    }}
                />
            </div>
        </>
    );
};
